export default "<ngx-loading-bar></ngx-loading-bar>\n<div id=\"app\">\n    <router-outlet></router-outlet>\n</div>\n";